import { IconSVG } from '../types';

export const SoundOff = ({ size, style }: IconSVG) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M16.775 19.575a9.464 9.464 0 01-.55.325c-.183.1-.375.192-.575.275a.874.874 0 01-.762 0 .988.988 0 01-.538-.575.85.85 0 01.038-.737c.125-.242.312-.421.562-.538.117-.05.225-.104.325-.162.1-.059.2-.121.3-.188L12 14.8v2.775c0 .45-.204.763-.612.938-.409.175-.771.104-1.088-.213L7 15H4a.967.967 0 01-.712-.287A.968.968 0 013 14v-4c0-.283.096-.52.288-.712A.968.968 0 014 9h2.2L2.1 4.9a.948.948 0 01-.275-.7c0-.283.092-.517.275-.7a.948.948 0 01.7-.275c.284 0 .517.092.7.275l17 17a.948.948 0 01.275.7.948.948 0 01-.275.7.948.948 0 01-.7.275.948.948 0 01-.7-.275l-2.325-2.325zM19.6 16.8l-1.45-1.45a6.796 6.796 0 00.638-1.625c.141-.567.212-1.15.212-1.75a6.864 6.864 0 00-1.1-3.787 6.822 6.822 0 00-2.95-2.563 1.114 1.114 0 01-.55-.537.948.948 0 01-.05-.738c.1-.267.28-.458.538-.575a.93.93 0 01.787 0A8.832 8.832 0 0119.55 7.05c.967 1.467 1.45 3.108 1.45 4.925 0 .883-.12 1.733-.362 2.55A8.803 8.803 0 0119.6 16.8zm-3.35-3.35L14 11.2V8.85c0-.2.088-.346.263-.437a.493.493 0 01.512.012c.55.35.975.875 1.275 1.575.3.7.45 1.367.45 2a4.33 4.33 0 01-.25 1.45zM12 9.2L9.4 6.6l.9-.9c.317-.317.68-.387 1.088-.212.408.175.612.487.612.937V9.2z"
      />
    </svg>
  );
};
